module.exports = __webpack_public_path__ + "img/logo.fb96fd98.png";